// 下拉菜单触发器样式
export const DROPDOWN_TRIGGER_STYLE = [
  'inline-flex justify-center items-center w-[19px] h-[30px] rounded-[4px] cursor-pointer py-[7px] hover:bg-[#E5E5E5]',
];

// 下拉菜单箭头样式
export const DROPDOWN_ARROW_STYLE = [
  'inline-flex align-center justify-center rounded-[4px] cursor-pointer w-[13px] h-[30px] hover:bg-[#E5E5E5]',
];

// 下拉菜单项样式
export const DROPDOWN_MENU_ITEM_STYLE = [
  'flex items-center px-2 py-1.5 rounded-sm justify-center cursor-pointer hover:bg-[#E5E5E5]',
];

export const DROPDOWN_MENU_WRAPPER_STYLE = [
  'w-auto p-0 bg-white border border-[#D4D4D4] rounded-sm shadow-md animate-in fade-in-0 zoom-in-95 duration-200 z-index-9999',
];
